export default {
  // 查询列表
  AGENCY_CONTRACT_LIST: '/sales/orderTrade/listOrderTradeByPage',
  // 字典表查询
  DICT_LIST: '/maindata/dictData/listDataDictByDataType',
  // 查询代理合同详情
  AGENCY_CONTRACT_DETAIL: '/sales/orderTrade/getOrderTrade/',
  // 创建修改贸易合同--代理合同
  SAVE_AGENCY_CONTRACT: '/sales/orderTrade/saveOrderTrade',
  // 汇率查询
  GET_CURRENCY_EXCHANGE: '/maindata/currencyExchange/getCurrencyExchange',
  // 计算商品明细小计
  GET_ORDER_TOTAL: '/sales/orderTrade/getOrderTradeTotal',
  // 批量删除
  BATCH_DELETE_ORDER: '/sales/orderTrade/batchDeleteOrderTrade',
  // 批量提交审批
  BATCH_AUDIT: '/sales/orderTrade/batchAuditCommit',
  // 通过原币金额计算本币金额
  CAL_LOCAL_AMOUNT: '/sales/orderTrade/calculateLocalAmount',
  // 导出
  EXPORT: '/sales/orderTrade/export',
  // 币种查询
  LIST_CURRENCY: '/maindata/currency/listCurrency',
  // 采销合同明细
  LIST_CONTRACT: '/sales/order/listOrderByPage',
  // 双边、销售合同明细
  LIST_TRADEORDERANDORDER: '/sales/orderTrade/listTradeOrderAndOrder',
  //打印查询
  GET_FILE: '/maindata/dict/getFileTemplate',
  //打印
  EXPORT_PRINT: 'sales/orderTrade/exportPrint',
  /** 计算金额乘法 */
  GET_RETURN_MONEY_AMOUNT: '/sales/orderSalesReturn/getReturnMoneyAmount',
  // 打印下载
  GET_PRINT: '/sales/order/exportPrint',
  //获取本币
  GET_LEGER_CODE_NAME: '/maindata/ledger/codeName',
  /** 信用额度提交校验*/
  CHECK_AVAILABLE_AMOUNT: 'sales/creditLimitSummary/checkAvailableAmount',
  /** 海宁信用额度提交校验*/
  CHECK_AVAILABLE_AMOUNT_HN: 'sales/creditLimitSummary/checkAvailableHnOrderAmount',
  /**关闭激活撤销合同 */
  UPDATE_OTDER_STATUS: '/sales/orderTrade/updateOrderStatus',
  // 风控部门撤销审批
  POST_REVERT_API: '/sales/orderTrade/approvalOrderStatusForUndo',
  // 获取合作伙伴联系人
  GET_PARTNERINFOFORHN: '/maindata/partnersApi/getPartnerInfo',
  /**获取点价详情*/
  GET_ORDERSALEDETAIL_API: '/sales/orderSaleDetailPricing/selectByContractNo',
  //供应商确认
  UPDATE_STATUS_BY_SUPPLIER: '/sales/OUT_REQ/orderTrade/updateStatusBySupplier',
  /**海宁单采，双边获取点价详情*/
  GET_ORDERSALEDETAIL_API_HN: '/sales/orderPriceHistory/selectRevisedOrderPriceHistoryHn',
  // post 方法 检验外部合同号
  CHECK_EXTERNAL_CONTRACTNO: '/sales/orderTrade/checkExternalContractNo',

  //合同-更新合同正本已收（业务）:入参：{'contractNo':,'originalsReceivedBusiness':}
  UPDATE_TRADE_ORB: '/sales/orderTrade/updateOriginalsReceivedBusiness',
  //合同-更新合同正本已收（风控）:入参：{'contractNo':,'originalsReceivedRm':}
  UPDATE_TRADE_ORR: '/sales/orderTrade/updateOriginalsReceivedRm',
  // 删除申请
  DELETE_CONTRACT_COMMIT: '/sales/orderTrade/deleteContractCommit',
};
